import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import websal from '../../assets/logowebsal.png'
import { log_out } from '../../store/actions/login.actions'
import { SelectEmpresa } from './SelectEmpresa'
import Modal from 'react-modal';
import edit from '../../assets/sidebar/create-outline.svg'


export const NavBarRepresentantes = () => {

   
  const [toggleMenu, setToggleMenu] = useState(false)

  let claseMenu = toggleMenu ? 'hamburger active' : 'hamburger'
  const empresa  = useSelector(state => state.app.empresa)


   const dispatch = useDispatch()

    const salir = () => {
 

       dispatch(log_out())
       localStorage.clear()


    }


    const [modalIsOpen, setIsOpen] = useState(false)

    const [detalles, setDetalles] = useState({})

    function openModal(firm) {
      setIsOpen(true);
      setDetalles(firm)


  }

  
  function closeModal() {
      setIsOpen(false);


  }
  

  const customStyles = {
      content: {
      top: '18%',
      padding:'20px',
      paddingLeft:"40px",
      paddingRight:"40px",
      width:"250px",
      // margin:'0 auto',
      height:'240px'
      },
  };


  return (





<nav className="nav"  >

  
<div className='contenedorImgtelefono' >
     
          <NavLink
                to="/home"
              
              >
                <img src={websal} alt='logo'  />

          </NavLink>
      </div>
       



      {toggleMenu  &&

      <>


      
      
      
      
      
      
      <ul>


      <div onClick={() => openModal() } className='selectEmpresaSidebar'>

                  

          <p> { empresa ? empresa.label : 'Selecciona empresa' } </p>
          <img  className='edit' src={edit} alt='ver' />



      </div>

     
   
     

            <li>
            <NavLink
              to="firma-representantes"
              onClick={() => setToggleMenu(false) }
    
              className={({ isActive }) =>
                isActive ? 'activeClassName' : 'BotonNav'
              }
            >
              Firma Digital
            </NavLink>
          </li>
      
      
      

   
    
     
     

      <button className="salir" onClick={ salir }  >
        <p>Salir</p>
      </button>

     

    </ul>

    </>
      
      }

 


      <button type='button' className={claseMenu} onClick={() => setToggleMenu(!toggleMenu) } >
        <span className='line'></span>
        <span className='line'></span>
        <span className='line'></span>
      </button>


                     <Modal
                                      isOpen={modalIsOpen}
                                    
                                      onRequestClose={closeModal}
                                      style={customStyles}
                                      contentLabel="Example Modal"
                                      ariaHideApp={false}
                                  >
                                                                                          
                            <div className='contenedorSelectEmpresa'>

                                 <SelectEmpresa/>





                                 <button className='buttonContinuarSelectEmpresa' onClick={closeModal} >Continuar</button>
                                                                                        
                             </div>
                             
                            </Modal>
   
    </nav>





    
  )
}
